export interface IGenerateOgqlQueryResponse {
  visualizationQuery: string;
  detailTableQuery: string;
  detailTableCountQuery: string;
  fullReportCountQuery: string;
  viewId: string;
  chartType: string;
}

export enum EQueryType {
  visualizationQuery = 'visualization',
  detailTableQuery = 'detailTable',
  detailTableGroupChildQuery = 'detailTableGroupChild',
  detailTableCountQuery = 'detailTableCount',
  detailTableSumQuery = 'detailTableSumQuery',
  fullReportCountQuery = 'fullReportCount',
  columnSearchQuery = 'columnSearch',
  calculationPreview = 'calculationPreview',
  conditionalPreview = 'conditionalPreview',
  dimensionalSummaryTableGroupData = 'dimensionalSummaryTableGroupData',
  pivotColumn = 'pivotColumn',
  pivotRows = 'pivotRows',
  pivotChildRows = 'pivotChildRows',
  dimensionalSummaryTableChildData = 'dimensionalSummaryTableChildData',
  detailTableExportQuery = 'detailTableExport',
  summaryTableQuery = 'summaryTable'
}

export enum ERequestType {
  storiesDetailTileEmbed = 'storiesDetailTileEmbed'
}
